import React from 'react'
import Tokens from '../Tokens'
import useAuthHook from '../userAuth'
import { Link } from 'react-router-dom'
import Button from '../components/Button'

const TokenPage = () => {
  const { user } = useAuthHook()

  return (
    <div className='mx-auto max-w-3xl p-4 text-left'>
      <div className='mb-5 flex items-center justify-between'>
        <div>
          <h1 className='text-3xl font-bold text-gray-900'>Access Tokens</h1>
          <p className='mt-1 text-sm text-gray-500'>Documentation access tokens for customers.</p>
        </div>
        <Link to='/tokens/new'>
          <Button>Create Token</Button>
        </Link>
      </div>
      <Tokens user={user} />
    </div>
  )
}

export default TokenPage
